/**
 * Detects whether the app is running inside a React Native WebView
 *
 * Detection order:
 * 1. Explicit query param (?webview=1 or ?embedded=1) → recommended
 * 2. react-native-webview bridge (window.ReactNativeWebView)
 * 3. Custom injected flag (window.__RN_WEBVIEW__)
 */
export const isReactNativeWebView = () => {
  if (typeof window === 'undefined') return false;

  try {
    // 1️⃣ Query param check (preferred & explicit)
    const params = new URLSearchParams(window.location.search);
    const webviewParam = params.get('webview') || params.get('embedded');

    if (webviewParam === '1' || webviewParam === 'true') {
      return true;
    }

    // 2️⃣ Official react-native-webview bridge
    if (window.ReactNativeWebView) {
      return true;
    }

    // 3️⃣ Optional injected flag
    if (window.__RN_WEBVIEW__ === true) {
      return true;
    }

    return false;
  } catch (e) {
    return false;
  }
};
